import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, DatePicker, Button, Input, Modal, Tooltip } from 'components';
import { CleanIcon, AddIcon, XLSIcon, DeleteIcon, EditIcon } from 'assets/icons';
import moment from 'moment';
import { ServiceService } from 'services';
import { Globals } from 'utils';
import ModalCreate from './modal-create';
import ModalUpload from './modal-upload';
import ModalView from './modal-view';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Services extends React.Component<Props> {

	timer: any = undefined;

	state = {
		data: [],
		page: 1,
		last_page: 1,
		header: [
			'Tipo de servicio',
			'Precio',
			'Descripción',
			'Acción'
		],
		form: INITIAL_STATE,
		visible: false,
		visible_upload: false,
		visible_view: false,
		item: null,
		services: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Servicios',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.loadData();
		this.load();
	}

	loadData = async () => {
		const res: any = await ServiceService.clinic.getData({
			withoutLoading: true
		});
		this.setState({
			services: res.services
		});
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ServiceService.clinic.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			user_id: this.props.user?.id
		});
		this.setState({
			data: res.services.rows,
			last_page: res.services.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_view: true,
			item
		});
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	openExcel = () => {
		this.setState({
			visible_upload: true
		});
	}

	onClose = () => {
		this.setState({
			item: null,
			visible: false
		},() => this.load(true));
	}

	onCloseView = () => {
		this.setState({
			item: null,
			visible_view: false
		},() => this.load(true));
	}

	onCloseUpload = () => {
		this.setState({
			item: null,
			visible_upload: false
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});	
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el servicio?',async () => {
			await ServiceService.clinic.delete({
				service_id: item.id
			});
			this.load(true);
		});
	}
	
	render() {
		const { visible, visible_upload, visible_view } = this.state;

		return (
			<div id="clinic-services">
				<Modal
		          className="modal-clinic-create-service"
		          visible={ visible }
		          withoutClose={ true }
		          onClose={ () => this.onClose() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalCreate
		          	services={ this.state.services }
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-clinic-view-service"
		          visible={ visible_view }
		          withoutClose={ true }
		          onClose={ () => this.onCloseView() }
		        >
		          <ModalView
		          	item={ this.state.item }
		            onClose={ () => this.onCloseView() } />
		      	</Modal>

		      	<Modal
		          className="modal-clinic-service-upload"
		          visible={ visible_upload }
		          withoutClose={ true }
		          onClose={ () => this.onCloseUpload() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalUpload
		            onClose={ () => this.onCloseUpload() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-4">
						<Input
							value={ this.state.form.search }
							name="search"
							label="Buscar por nombre"
							placeholder="Buscar"
							className="input-table"
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-2">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>
					<div className="col-md-6 text-right">
						<Button className="btn-add btn-excel" onClick={ () => this.openExcel() }>
							<img src={ XLSIcon } />
							<div>
								Subir masivamente servicios en excel
							</div>
						</Button>
					</div>
				</div>

				<Table title="Historial de Registro de Servicios" data={ this.state.data.length } rightAlign={[ 3 ]} header={ this.state.header } titleRight={
					<Button className="btn-add" onClick={ () => this.add() }>
						<img src={ AddIcon } />
						Nuevo
					</Button>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.service?.name }</td>
								<td>{ Globals.formatMiles(i.amount) }</td>
								<td>
									<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,i) }>
										Ver
									</a>
								</td>
								<td className="text-right">
									<Tooltip title="Editar">
										<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
											<img src={ EditIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Eliminar">
										<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
											<img src={ DeleteIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Services);